import './Toolbox.css'

const stacks = [
    { no: 'No. 1', title: 'Front-End', items: ['HTML5', 'CSS3', 'JavaScript', 'TypeScript', 'React', 'Sass', 'Bootstrap', 'jQuery', 'Vite'] },
    { no: 'No. 2', title: 'Back-End', items: ['Node.js', 'EJS', 'REST APIs', 'MySQL', 'MongoDB'] },
    { no: 'No. 3', title: 'Workshop', items: ['Git', 'GitHub', 'Figma', 'Scrum', 'Teaching', 'Freelance'] }
];

export default function Toolbox() {
    return (
        <section id='skills' className='toolbox'>
            <div className='container'>
                <div className='toolbox-head' data-reveal>
                    <div>
                        <p className='kicker'>§ 02 — The Toolbox</p>
                        <h2 className='section-title'>Type specimen of <em>my stack</em></h2>
                    </div>
                    <p className='toolbox-note'>Set in metal, hand-inked, and used daily from database to button.</p>
                </div>
                <div className='toolbox-grid' data-reveal>
                    {stacks.map(stack => (
                        <div key={stack.title} className='toolbox-case'>
                            <div className='toolbox-case-head'>
                                <h3>{stack.title}</h3>
                                <span>{stack.no}</span>
                            </div>
                            <ul className='toolbox-items'>
                                {stack.items.map(item => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
